export default {
  steps_introduction: "Introduction",
  steps_report_drawings_notice: "Report drawings notice",
  steps_quiz_of_safety_knowledge: "Safety knowledge quiz",
  steps_insurance_management_regulations: "Insurance regulations",
  steps_home_contractor_service_group: "Producer service group",
  btn_start_report_drawings: "start",
  checkbox_known: "known",
  btn_next: "next",
  btn_previous: "previous",
  btn_submit: "Submit",
  tips_wrong_answer: "Wrong answer",
  tips_right_answer: "Right answer",
  title_insurance_management_regulations:
    "Insurance management regulations for exhibition worker",
  title_home_contractor_service_group: "Producer group QR code",
  text_qr: "QR code",
  introduction_info_1:
    "When you first report in the current exhibition, the instructions for the report, the safety knowledge quiz, the insurance regulations for the construction workers, and the service group of the main contractor are mandatory readings. After reading, you will enter the reporting process.",
  introduction_info_2:
    "When you later enter the special report, click the “Add New Application” button in the upper right corner of the page to start the report.",
  introduction_info_3:
    "The system supports partial data saving. If you continue to report, you can find the history in the “application record” and click the “Modify” button to continue the report.",
  introduction_info_1_baima:
    "When you first report in the current exhibition, the instructions for the report, the safety knowledge quiz, the insurance regulations for the construction workers, and the service group of the main contractor are mandatory readings. After reading, you will enter the reporting process.",
  introduction_info_2_baima:
    "When you later enter the special report, click the “Add New Application” button in the upper right corner of the page to start the report.",
  introduction_info_3_baima:
    "The system supports partial data saving. If you continue to report, you can find the history in the “application record” and click the “Modify” button to continue the report."
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/drawings/drawingsNotice.js